import { createReducer } from "@reduxjs/toolkit";
import { VIDEO_ERROR, VIDEO_LIST, VIDEO_LOADING } from "../actions/types";

const initials = {
  data: [],
  thisPage: 0,
  allPages: 0,
  error: false,
  loading: false,
};

const myVideoReducer = createReducer(initials, (builder) => {
  builder
    .addCase(VIDEO_LOADING, (s) => {
      s.loading = true;
    })
    .addCase(VIDEO_ERROR, (s, { payload }) => {
      s.error = payload;
      s.loading = false;
    })
    .addCase(VIDEO_LIST, (s, { payload }) => {
      s.data =
        payload?.thisPage === 1
          ? payload?.data
          : [...s?.data, ...payload?.data];
      s.count = payload.count;
      s.allPages = payload.allPages;
      s.thisPage = payload.thisPage;
      s.loading = false;
    });
});

export default myVideoReducer;
